type EventType = 'lead-submit' | 'flash-lead-submit' | 'promo-banner';

const sendRudderstackEvent = (eventType: EventType, data, integrations?) => {
  window.rudderanalytics.track(
    eventType,
    {
      source: 'content-ui',
      ...data
    },
    {
      ...integrations
    }
  );
};

export default sendRudderstackEvent;
